import { Component, OnInit } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
import { ZipCodeFloridaService } from './zip-code-florida.service';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';

@Component({
  selector: 'app-zip-code-florida',
  templateUrl: './zip-code-florida.component.html',
  styleUrls: ['./zip-code-florida.component.scss'],
})
export class ZipCodeFloridaComponent implements OnInit {
  protected activeAdd = false;
  protected enabledBtn = false;
  protected zipCodeFloridaSelected = 0;

  ///serch
  protected filter = '';

  protected gridFacility: GridOptions;
  protected data: any;
  searchGridForm;

  constructor(
    protected _service: ZipCodeFloridaService,
    protected toastrAlertHelper: ToastrAlertHelper,
    private _loading: T2LoadingService,
    private swetAlert: SweetAlertHelper
  ) {
    this.defineColumns();
  }

  /**
   * @name defineColumns
   * @description
   * @returns Array
   */
  defineColumns() {
    this.gridFacility = <GridOptions>{
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      filter: true,
      columnDefs: [
        {
          headerName: 'ZipCode',
          field: 'zip',
          colId: 'zip',
          width: 350,
        },
        {
          headerName: 'City',
          field: 'city',
          colId: 'city',
          width: 200,
        },
        {
          headerName: 'County',
          field: 'county',
          colId: 'county',
          width: 200
        },
      ],
      onGridReady: () => {
        this.gridFacility.api.sizeColumnsToFit();
        this.callService();
      },
    };
  }

  addNewFacility() {
    this.changeActiveAdd();
    this.zipCodeFloridaSelected = 0;
    this.enabledBtn = false;
    this.gridFacility.api.deselectAll();
  }

  callService() {
    this._service.getZipCodeFlorida().subscribe((data) => this.loadData(data));
  }

  changeActiveAdd(event?) {
    this.activeAdd = !this.activeAdd;
    if (event === false) {
      this.activeAdd = true;
      this.enabledBtn = false;
    }
  }

  editFacility() {
    if (this.zipCodeFloridaSelected === 0) {
      this.toastrAlertHelper.warning('Please, check a row');
    } else {
      this.changeActiveAdd();
    }
  }

  loadData(data) {
    this.data = data;
    if (this.gridFacility) {
      if (this.gridFacility.api) {
        const filter = this.gridFacility.api.getFilterModel();
        this.gridFacility.api.setRowData(data);
        this.gridFacility.api.setFilterModel(filter);
      }
    }
  }

  onNotify(resp: any): void {
    if (resp.success) {
      this.zipCodeFloridaSelected = 0;
      if (this.activeAdd) {
        this.changeActiveAdd();
      }
      this.enabledBtn = false;
      this.swetAlert.createCustomAlert({ text: resp.message, type: 'success' });
    } else {
      this.swetAlert.createCustomAlert({ text: resp.message, type: 'error' });
    }
    this.callService();
  }

  onPress(event) {
    this.filter = event;
  }

  public search(event) {
    if (event.key === 'Enter' || event.key === undefined) {
      if (this.searchGridForm) {
        const regex = new RegExp(this.searchGridForm, 'i');
        const filteredData = this.data.filter(
          (filter: any) =>
            regex.test(filter.zip) ||
            regex.test(filter.city) ||
            regex.test(filter.county)
        );
        this.data = filteredData;
        if (this.gridFacility.api) {
          const filter = this.gridFacility.api.getFilterModel();
          this.gridFacility.api.setRowData(filteredData);
          this.gridFacility.api.setFilterModel(filter);
        }
      } else {
        this.callService();
      }
    } else {
      if (event.target.value.length < 2 || this.searchGridForm.length < 2) {
        this.callService();
      }
    }
  }

  setSelectedFacility(event) {
    this.enabledBtn = true;
    event.node.setSelected(true);
    this.zipCodeFloridaSelected = event.data.zip;
  }

  showWarningWithMessage(message) {
    this.toastrAlertHelper.warning(message);
  }

  delete() {
    if (this.zipCodeFloridaSelected) {
      this._loading.show();
      this._service
        .deleteZipCode(this.zipCodeFloridaSelected.toString())
        .finally(() => {
          this._loading.hiden();
        })
        .subscribe({
          next: () => {
            this.swetAlert.createCustomAlert({
              text: 'Zip Code Delete Successfully',
              type: 'success',
              showConfirmButton: false,
              timer: 2000,
            });
            this.callService();
          },
          error: (err) => {
            this.swetAlert.captureException(err);
          },
        });
    }
  }
  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/pages/zip-code-florida/zip-code-florida.component.ts